<app-layout-workarea [heading]="!useCustomHeader() ? 'Container Query Test' : undefined">
  <!-- Simple header mode - header actions -->
  @if (!useCustomHeader()) {
    <div slot="header-left">
      <button class="btn btn-outline-secondary btn-sm me-2" (click)="toggleHeaderMode()">Switch to Custom Header</button>
      <button class="btn btn-outline-info btn-sm" (click)="toggleTabs()">
        {{ showTabs() ? 'Hide Tabs' : 'Show Tabs' }}
      </button>
    </div>
  }

  <!-- Custom header mode - complete control -->
  @if (useCustomHeader()) {
    <div slot="custom-header">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center">
          <div class="badge bg-success me-3">CUSTOM</div>
          <h1 class="mb-0">🎨 Custom Header Design</h1>
        </div>
        <div class="d-flex align-items-center gap-2">
          <small class="text-muted">Completely overridable header</small>
          <button class="btn btn-outline-primary btn-sm me-2" (click)="toggleHeaderMode()">Switch to Simple Header</button>
          <button class="btn btn-outline-info btn-sm" (click)="toggleTabs()">
            {{ showTabs() ? 'Hide Tabs' : 'Show Tabs' }}
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Optional tabs using content projection -->
  @if (showTabs()) {
    <div slot="tabs">
      <nav class="nav nav-tabs">
        <button class="nav-link active" type="button">
          <ci-phosphor-icon name="cards" size="sm" class="me-2" />
          Responsive Cards
        </button>
        <button class="nav-link" type="button">
          <ci-phosphor-icon name="layout" size="sm" class="me-2" />
          Layout Testing
        </button>
        <button class="nav-link" type="button">
          <ci-phosphor-icon name="browser" size="sm" class="me-2" />
          Container Queries
        </button>
        <button class="nav-link" type="button">
          <ci-phosphor-icon name="device-mobile" size="sm" class="me-2" />
          Responsive Design
        </button>
      </nav>
    </div>
  }

  <div class="row mb-4">
    <div class="col-12">
      <div class="alert alert-info">
        <h6>Header Mode Demo:</h6>
        <p class="mb-2">
          <strong>Current mode:</strong>
          <span class="badge bg-{{ useCustomHeader() ? 'success' : 'primary' }}">
            {{ useCustomHeader() ? 'Custom Header' : 'Simple Header' }}
          </span>
          <strong class="ms-3">Tabs:</strong>
          <span class="badge bg-{{ showTabs() ? 'success' : 'secondary' }}">
            {{ showTabs() ? 'Visible' : 'Hidden' }}
          </span>
        </p>
        <ul class="mb-0">
          <li><strong>Simple Header:</strong> Uses title input + header-left slot for actions</li>
          <li><strong>Custom Header:</strong> Complete control over header content via custom-header slot</li>
          <li><strong>Optional Tabs:</strong> Uses tabs slot for conditional content projection</li>
        </ul>
      </div>

      <h2>Responsive Cards Test</h2>
      <p class="text-muted">
        Cards should stack: 1 column (xs), 2 columns (sm-md), 3 columns (lg+)
        <br />
        <strong>Note:</strong> Responsive behavior is based on content area width, not viewport width!
      </p>
    </div>
  </div>

  <div class="row g-3">
    @for (card of cards; track card; let i = $index) {
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">Card {{ i + 1 }}</h5>
          </div>
          <div class="card-body">
            <p class="card-text">{{ card.content }}</p>
            <div class="badge bg-primary">{{ card.category }}</div>
          </div>
          <div class="card-footer text-muted">
            <small>Last updated {{ card.updated }}</small>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <div class="alert alert-secondary">
        <h6>Container Query Test Instructions:</h6>
        <ul class="mb-0">
          <li>Expand/collapse the sidebar to see responsive behavior</li>
          <li>Cards respond to <strong>content area width</strong>, not viewport width</li>
          <li>Compare with regular Bootstrap grid on other pages (responds to viewport)</li>
          <li>Toggle between header modes to see the different template options</li>
          <li><strong>Toggle tabs</strong> to test optional content projection</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Tall colored block to test scrolling and sticky headers -->
  <div class="row mt-5">
    <div class="col-12">
      <div
        style="
          height: 3000px;
          background: linear-gradient(to bottom, #e3f2fd, #bbdefb, #90caf9, #64b5f6);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <h3 style="color: #1976d2; text-align: center">Scroll Test Area</h3>
        <p style="color: #1976d2; text-align: center; max-width: 400px">
          This 3000px tall block allows you to test that both the main header and content header remain sticky when scrolling.
          Collapse/expand the sidebar to see container query responsive behavior.
        </p>
        <div style="margin-top: 20px; text-align: center; color: #1976d2">
          <strong>Test Features:</strong>
          <ul style="list-style: none; padding: 0; margin-top: 10px">
            <li>🔄 Header Mode Toggle</li>
            <li>👁️ Tabs Show/Hide</li>
            <li>📐 Sticky Headers</li>
            <li>📱 Container Queries</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout-workarea>
